import { render } from "./IntellifloOfficeDocumentsTable.vue?vue&type=template&id=1bd36430&scoped=true"
import script from "./IntellifloOfficeDocumentsTable.vue?vue&type=script&lang=js"
export * from "./IntellifloOfficeDocumentsTable.vue?vue&type=script&lang=js"

import "./IntellifloOfficeDocumentsTable.vue?vue&type=style&index=0&id=1bd36430&scoped=true&lang=css"

import exportComponent from "/tmp/build_905a1b4c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bd36430"]])

export default __exports__